<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">VueTS App</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item" v-for="link in links">
                        <a v-bind:href="link['link'] ? link['link'] : '#'"
                            v-bind:class="(link.id == active)?'nav-link active':'nav-link'">
                            {{link.text}}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    module.exports = {
        props: ['active'],
        data: function () {
            return {
                links: [
                    {text: "Home", id: "home", link: "/index.html"},
                    {text: "About", id: "about"},
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>